import { IResource } from './interface';
import enTranslationMessages from './translations/en.json';

const DEFAULT_LOCALE = 'en';

const defaultFormattedMessages: IResource = enTranslationMessages;

const formatTranslationMessages = (locale: string, messages: IResource): IResource => {
  const flattenFormattedMessages = (formattedMessages: IResource, key: keyof IResource) => {
    const formattedMessage =
      !messages[key] && locale !== DEFAULT_LOCALE ? defaultFormattedMessages[key] : messages[key];
    return Object.assign(formattedMessages, { [key]: formattedMessage });
  };
  return (Object.keys(messages) as Array<keyof IResource>).reduce(
    flattenFormattedMessages,
    {} as IResource
  );
};

const translationMessages = {
  en: formatTranslationMessages('en', enTranslationMessages),
};

export { translationMessages, DEFAULT_LOCALE, formatTranslationMessages };
